module.exports = __webpack_public_path__ + "img/project12_7.png.01b15848.webp";